'use strict';

var base = require('./base');
var scrollAnimate = require('base/components/scrollAnimate');

const { promotionCounter } = require('./promotionCounter');

/*
* Author :  Sanjeev Kumar Sharma
* Function : hide - show product attributes in detail section on pdp
*/

promotionCounter();

function hidefeature(hide){
    var features = $('#productDetails .features-lists-item');

    if(features.length>10){
        if(hide){
            $('.view-more-features').addClass('d-block').removeClass('d-none');
            $('.view-less-features').addClass('d-none').removeClass('d-block');
        }else{
            $('.view-more-features').addClass('d-none').removeClass('d-block');
            $('.view-less-features').addClass('d-block').removeClass('d-none');
        }
    }else{
        $('.view-more-features').addClass('d-none');
        $('.view-less-features').addClass('d-none');
    }

    features.each(function(key, val) { 
        if(key >= 10){
            if(hide){
                val.classList.add('d-none');
            }else{
                val.classList.remove('d-none');
            }
        }else{
            val.classList.remove('d-none');
        }
    });
}

$(document).on('click','.view-more-features', function(){
    hidefeature(false);
});
$(document).on('click','.view-less-features', function(){
    hidefeature(true);
});

hidefeature(true);


/*
* Author :  Sanjeev Kumar Sharma
* function :  read more cta for long description of product
*/

function readmore(){
    var el = $('.detail-description');
    var divHeight = el.outerHeight();
    var lineHeight = 18;
    var lines = divHeight / lineHeight;
    
    if(lines > 4 ){            
        el.addClass('truncate-overflow');
        el[0].style.webkitBoxOrient='vertical';
        $('.read-more').removeClass('d-none').addClass('d-block');
        $('.read-less').removeClass('d-block').addClass('d-none');
    }else{
        el.removeClass('truncate-overflow');
        $('.read-more').removeClass('d-block').addClass('d-none');
        $('.read-less').removeClass('d-block').addClass('d-none');
    }
}

setTimeout(function() {
    readmore();
}, 200);

$(window).on('resize', function () {
    if(!$('.detail-description').hasClass('truncate-overflow')){
        readmore();
    }
});

$(document).on('click', '.read-more', function(){
    $('.detail-description').removeClass('truncate-overflow').css('margin-bottom','0');
    $('.detail-description')[0].style.webkitBoxOrient='vertical';
    $('.read-more').addClass('d-none').removeClass('d-block');
    $('.read-less').addClass('d-block').removeClass('d-none');
});

$(document).on('click', '.read-less', function(){
    $('.detail-description').addClass('truncate-overflow');
    $('.read-less').addClass('d-none').removeClass('d-block');
    $('.read-more').addClass('d-block').removeClass('d-none');
});



/*
* Author :  Sanjeev Kumar Sharma
* Funtion : social sharing on PDP
*/


function socialSharingIcon () {
    if ($('.social-sharing-icons').length) {
        var facebookShareUrl = 'https://www.facebook.com/share.php?u=';
        var instagramShareUrl = 'https://www.instagram.com/?url=';
        var twitterShareUrl = 'https://twitter.com/intent/tweet?url=';
        var whatsAppShareUrl = 'https://wa.me/?text=';
        var mailto = 'mailto:?body='
        var productUrlToShare = window.location.href;
        $('.social-sharing-icons .facebook-share').attr('href', facebookShareUrl + productUrlToShare);
        $('.social-sharing-icons .instagram-share').attr('href', instagramShareUrl + productUrlToShare);
        $('.social-sharing-icons .twitter-share').attr('href', twitterShareUrl + productUrlToShare);
        $('.social-sharing-icons .whatsapp-share').attr('href', whatsAppShareUrl + productUrlToShare);
        $('.social-sharing-icons .mailto').attr('href', mailto + productUrlToShare);
    }
    
    if ($(window).width() < 991) {
        /* share options */
        const shareButton = document.querySelector('.share-button');
        const shareDialog = document.querySelector('.share-dialog');
        const closeButton = document.querySelector('.close-button');

        if (shareButton) {
            let url = $('.product-url-hidden').text();
            shareButton.addEventListener('click', () => {
                if (navigator.share) {
                    navigator.share({
                        url,
                    }).then(() => {

                    })
                        .catch(console.error);
                } else {
                    shareDialog.classList.add('is-open');
                }
            });
        }

        if (closeButton) {
            closeButton.addEventListener('click', () => {
                shareDialog.classList.remove('is-open');
            });
        }
    } else {
        $('.share-button').on('click', (e) => {
            e.preventDefault();
            $('.social-sharing-icons.top-share').fadeIn(300, function () { $(this).focus(); });
        });

        $('.social-sharing-icons').on('blur', function () {
            $(this).fadeOut(300);
        });

    }
};

socialSharingIcon();

$(document).mouseup(function(e) 
{
    var container = $(".social-sharing-icons");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        container.hide();
    }
});


/*
* Author :  Sanjeev Kumar Sharma
* Function: View similar products on PDP
*/

function viewSimilarProducts(){
    if($('.view-simliar-products').length){
        $('.product-view-similar').show();
    }

    $(document).on('click', '.product-view-similar-icon', function (e) {
        scrollAnimate($('.view-similar'));
    });
};

viewSimilarProducts();


/*
* Author :  Sanjeev Kumar Mishra
* function :  prevent carousel to hide behind header while scrolling
*/

$(window).on('scroll', function () {

    if($('.slider-section-sticky').length) {
        if($('header').hasClass('sticky-header')) {
            $('.slider-section-sticky').css('top', $('header').outerHeight() + 16 );
        }
        else {
            $('.slider-section-sticky').css('top', '16px');
        }
    }

    if( $(window).width() < 544 ) {
        if (isInViewport($('.prices-add-to-cart-actions:not(.sticky-to-bottom)'))) {
            $('.prices-add-to-cart-actions.sticky-to-bottom').addClass('d-none');
            $('.sticky-whatsapp').removeClass('level-up');
        } else {
            (isInViewport($('.view-similar')) || isInViewport($('#footercontent'))) ? ($('.prices-add-to-cart-actions.sticky-to-bottom').addClass('d-none'), $('.sticky-whatsapp').removeClass('level-up')) : ($('.prices-add-to-cart-actions.sticky-to-bottom').removeClass('d-none'), $('.sticky-whatsapp').addClass('level-up'));
        }
    }
    if($('.view-simliar-products').length){
        $('.promoted-products-box').show();
    }

    $(".view-simliar-products, .recently-view-products, .best-seller-products").closest('.fullpage-gradient').removeClass('d-none');
    if($('.view-simliar-products .product-grid, .recently-view-products .product-grid, .best-seller-products .product-grid').length) {
        $('.view-simliar-products .product-grid, .recently-view-products .product-grid, .best-seller-products .product-grid').not('.slick-initialized').slick({
            slidesToShow: 5,
            slidesToScroll: 5,
            arrows: true,
            infinite: true,
            dots: false,
            draggable:true,
            prevArrow: '<i class="fa fa-chevron-left slick-prev"></i>',
            nextArrow: '<i class="fa fa-chevron-right slick-next"></i>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4
                    },
                },
                {
                    breakpoint: 542,
                    settings: {
                        slidesToScroll: 2,
                        slidesToShow: 2
                    },
                }
            ]
        });
    }
});


$(document).ready(function () {
    if( $(window).width() < 544 ) {
        if (isInViewport(!$('.prices-add-to-cart-actions:not(.sticky-to-bottom)'))) {
            $('.prices-add-to-cart-actions.sticky-to-bottom').removeClass('d-none');
            $('.sticky-whatsapp').addClass('level-up');
        } else {
            $('.prices-add-to-cart-actions.sticky-to-bottom').addClass('d-none');
            $('.sticky-whatsapp').removeClass('level-up');
        }
        
    }

    $(document).on('click', '#sizeGuideLink', function(event) {
        event.preventDefault(); // Prevent the default link behavior
        let anchorUrl = $(this).attr('href');
        let pid = $(this).data('pid');
        let selectedSize = $('.controlgroup .size-selector-box.active').attr('data-attr-value'); //$(this).attr('data-size');
        let displaySizeValue = $('.controlgroup .size-selector-box.active').attr('data-value');

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'size_guide_open',
            product_id: pid
        });

        let $sizeChartContainer = $('#pdpSizeChartContainer');
        let sizeChartModal = $sizeChartContainer.find('#pdpSizeChartModal');
        if (sizeChartModal.length > 0) {
            setSelectedSize(selectedSize, displaySizeValue);
            sizeChartModal.modal('show');
        } else {
            $.ajax({
                url: anchorUrl,
                type: 'GET',
                success: function(data) {
                    // Handle the response data
                    $sizeChartContainer.html(data);
                    setSelectedSize(selectedSize, displaySizeValue);
                    $('#pdpSizeChartModal').modal('show');
                },
                error: function(error) {
                    // Handle the Error Case
                }
            });
        }
    });

    $(document).on('change', ".toggle-container input[type='radio']", function() {
        let currValue = (this).value;
        let currActiveSizeClass = '.sizechart-' + currValue;
        $('.sizechart-inches, .sizechart-cms').addClass('d-none');
        $(currActiveSizeClass).removeClass('d-none');
    });

    $(document).on('click', '.size-chart-content .nav-item a', function() {
        var tabId = $(this).attr('id');
        var pid = $('#pdpSizeChartModal').data('pid');
        var tabName = tabId === 'size-guide-tab-1' ? 'body_measurement' : 'garment_measurement';
        let bodyMeasurementContent = document.querySelector('.content-body-measurement'),
            garmentMeasurementContent = document.querySelector('.content-garment-measurement');

        if (tabName == 'garment_measurement') {
            garmentMeasurementContent.classList.remove('hidden');
            bodyMeasurementContent.classList.add('hidden');
        } else {
            garmentMeasurementContent.classList.add('hidden');
            bodyMeasurementContent.classList.remove('hidden');
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'size_guide_tab_click',
            tab_name: tabName,
            product_id: pid
        });

        tabId === 'size-guide-tab-1' ? $('.toggle-container').removeClass('d-none') : $('.toggle-container');
    })


    var colorLength = $('.color-swatch-area .color-attribute').length;
    if (colorLength > 5) {
        $('span.more-colors').removeClass('d-none');
        $('.color-swatch-area').find('.color-attribute').hide();
        $('.color-swatch-area').find('.color-attribute').slice(0, 5).show();
    } else {
        $('span.more-colors').addClass('d-none');
        $('.color-swatch-area').find('.color-attribute').show();
    }

    setTimeout( function() {
        if ($('.product-detail .size-selector-box').length == 1 && !$('.product-detail .size-selector-box').hasClass('selected')){
            $('.product-detail .size-selector-box').trigger('click');
        }
    }, 500);

    if ($('.color-size').val() == 1) {
        $(".product-detail").find('.disabled-button-pdp').hide();
    }
});

$(document).on('click', '.js-select-size', function() {

    $(this).closest('.tab-pane.active').find('.custom-radio').removeClass('disabled');
    $(this).closest('.custom-radio').addClass('disabled');
    $('.js-add-to-cart-Size-chart').removeAttr('disabled');

    var sizeVal = $(this).attr('data-size');
    $('div[data-role="controlgroup"] .size-button> a.size-selector-box').each(function(  ) {
        var sizePdpVal = $(this).attr('data-attr-value');

        if(sizeVal == sizePdpVal) {
            $('div[data-role="controlgroup"] .size-button> a.size-selector-box').each(function() {
                var selectedSizeGuide = $(this).attr('data-attr-value');
            
                if(sizeVal == selectedSizeGuide) {
                    $(this).trigger("click");
                }
            });
            
        }
    });
}); 

$(document).on('click', 'div[data-role="controlgroup"] .size-button> a', function() {
    $('.size-chart').attr('data-size', $(this).attr('data-value'));
}); 

$(document).on('click', '.js-add-to-cart-Size-chart', function(e) {
    e.stopPropagation();
 
    // support BOTH tabs (size chart + garment)
    const selectedSizeInput = $("input[name='size']:checked, input[name='garment-size']:checked");
 
    if (selectedSizeInput.length) {
        const selectedSize = selectedSizeInput.attr('data-size');
 
        // close modal
        $('#pdpSizeChartModal').modal("hide");
 
        // trigger ATC
        $('.js-add-to-cart .add-to-cart-global').trigger("click");
    }
});

function setSelectedSize(selectedSize, displaySizeValue) {
    $('.size-selector-box').each(function( index ) {
        if($(this).children().hasClass('size-buttons-size-strike')) {
            var sizePdpVal = $(this).attr('data-attr-value');
            $("[data-size="+sizePdpVal+"]").parent(".custom-radio").hide();
        }
    });

    if(!selectedSize){
        $('.js-add-to-cart-Size-chart').attr('disabled','disabled')
    }

    $('.js-select-size').each(function( index ) {
        var sizePopUPVal = $(this).attr('data-size');
        $(this).removeAttr('checked');
        if(selectedSize == sizePopUPVal || displaySizeValue == sizePopUPVal ) {
            $('.js-add-to-cart-Size-chart ').removeAttr('disabled');
            $(this).prop("checked", true);
            $(this).closest('.custom-radio').addClass('disabled');
        } else {
            $(this).prop("checked", false);
            $(this).closest('.custom-radio').removeClass('disabled');
        }
    });
}

function isInViewport(el) {
    if (!el || !el.length) return false;

    var rect = el[0].getBoundingClientRect();

    return (
        rect.top < window.innerHeight &&
        rect.bottom > 0
    );
}

$(document).on('click',
    '.product-detail .carousel-thumbnail .video-item, ' +
    '.product-detail video', function (e) {

    e.preventDefault();

    let url = $('#customerNoUrl').val(),
        indexItem =  $(this).data('slick-index'),
        productId = document.querySelector('.product-detail')?.getAttribute('data-pid'),
        productName = document.querySelector('.product-name').textContent.trim(),
        customerId='';

    $.ajax({
        url,
        type: 'get',
        success(data) {
            if(data.customerId){
                customerId = data.customerId;
            }

            // data layer for pdp-video-clicks
            dataLayer.push({
                event: "pdp-video-click",
                product_id: productId ? productId : '',
                productName: productName ? productName : '',
                user_id: customerId ? customerId : '',
                name: data.customerName ? data.customerName : 'Customer',
                email_id: data.customerEmail ? data.customerEmail : '',
                mobile_number: data.mobileNumber ? data.mobileNumber : '',
                product_url: window.location.href, // Need to pass current page url
            });
        },
        error() {
            console.error('Error fetching content:', error);
        },
    });
});

document.querySelectorAll('.product-detail video').forEach(function(video) {
    video.addEventListener('play', videoEventHandler);
    video.addEventListener('pause', videoEventHandler);
});

function videoEventHandler(e) {
    var productDetail = document.querySelector('.product-detail');
    var productNameEl = document.querySelector('.product-name');

    var productId = productDetail ? productDetail.getAttribute('data-pid') : '';
    var productName = productNameEl ? productNameEl.textContent.trim() : '';

    dataLayer.push({
        event: "pdp-video-shown",
        type: e.type,
        product_id: productId,
        productName: productName,
        product_url: window.location.href
    });
}
